<div class="flex flex-column consult__section consult__examination">
  <div class="col-12 inline-flex consult__section-subheading-group flex-wrap">
    <h3 class="col-12 inline-flex align-items-center lg:col-6 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer" for="examination_{{mainDetail?.id}}">{{screen.heading}}</label>
    </h3>
    <span class="col-12 lg:col-3 consult__section-help">{{screen.helpLeft}}</span>
    <span class="col-12 lg:col-3 consult__section-help">{{screen.helpRight}}</span>
  </div>

  <div class="inline-flex flex-column col-12 p-0 mt-2" *ngIf="mainDetail && expandSection && !readonly">
    <textarea pInputTextarea name="examination_{{mainDetail.id}}" [(ngModel)]="mainDetail.details" [rows]="4"
      class="uppercase m-0" validation></textarea>

    <small class="py-2">
      {{screen.disclaimer}} {{catalogsName}}
    </small>

    <div class="mt-2 align-self-end">
      <p-button [label]="screen.showDetail" (onClick)="showDetails = true"></p-button>
    </div>
  </div>
  <div hidden *ngIf="!readonly">
    <div *ngFor="let examination of examinations">
      <ms-consult-catalog-item-readonly [catalog]="examination" [readonly]="readonly">
      </ms-consult-catalog-item-readonly>
    </div>
  </div>

  <div class="col-12 p-0 mt-2" *ngIf="expandSection && readonly">
    <span *ngIf="mainDetail">{{mainDetail.details}} </span><span *ngFor="let examination of examinations"><b>;
        {{examination.name}}
        [{{examination.withEvidence ? 'CP' : 'SP'}}]</b> {{examination.details}}</span>
  </div>
</div>

<p-sidebar [(visible)]="showDetails" position="right" [blockScroll]="true" appendTo="body"
  [style]="{ width: '425px', maxWidth: '90%' }">
  <div class="inline-flex flex-column">
    <h3 class="text-base font-normal mb-2">
      {{screen.detailDescription}}
    </h3>

    <div *ngFor="let examination of examinations">
      <ms-consult-catalog-item [catalog]="examination" [readonly]="readonly"
        (catalogChange)="handleUpdateGlobalField($event)">
      </ms-consult-catalog-item>
    </div>
  </div>
</p-sidebar>